import type { ObjectValues } from 'common/types/util';

const Colors = {
  oidc: 'var(--color-oidc)',
  okta: 'var(--color-okta)',
  slack: 'var(--color-slack)',
  salesforce: 'var(--color-salesforce)',
  segment: 'var(--color-segment)',
  zapier: 'var(--color-zapier)',
  facebook: 'var(--color-facebook)',
  zendesk: 'var(--color-zendesk)',
  clickup: 'var(--color-clickup)',
  github: 'var(--color-github)',
  gong: 'var(--color-gong)',
  googleanalytics: 'var(--color-googleanalytics)',
  gsuite: 'var(--color-gsuite)',
  helpscout: 'var(--color-helpscout)',
  hubspot: 'var(--color-hubspot)',
  jira: 'var(--color-jira)',
  azure: 'var(--color-azure)',
  azureDevops: 'var(--color-azureDevops)',
  discord: 'var(--color-discord)',
  intercom: 'var(--color-intercom)',
  asana: 'var(--color-asana)',
  linear: 'var(--color-linear)',
  msteams: 'var(--color-msteams)',
  tldv: 'var(--color-tldv)',
  trello: 'var(--color-trello)',
  aha: 'var(--color-aha)',
  productboard: 'var(--color-productboard)',
  pendo: 'var(--color-pendo)',
  userVoice: 'var(--color-userVoice)',
  trustpilot: 'var(--color-trustpilot)',
  appStore: 'var(--color-appStore)',
  playStore: 'var(--color-playStore)',
  g2: 'var(--color-g2)',
  capterra: 'var(--color-capterra)',
  trustradius: 'var(--color-trustradius)',
  productHunt: 'var(--color-productHunt)',
  wordpress: 'var(--color-wordpress)',
  shopify: 'var(--color-shopify)',
  zoom: 'var(--color-zoom)',
  caseStudyAgencyAnalytics: 'var(--color-case-study-agencyanalytics)',
  caseStudyAhrefs: 'var(--color-case-study-ahrefs)',
  caseStudyAxios: 'var(--color-case-study-axios)',
  caseStudyClickup: 'var(--color-case-study-clickup)',
  caseStudyFigured: 'var(--color-case-study-figured)',
  caseStudyHive: 'var(--color-case-study-hive)',
  caseStudyKnak: 'var(--color-case-study-knak)',
  caseStudyMercury: 'var(--color-case-study-mercury)',
  caseStudyMissive: 'var(--color-case-study-missive)',
  caseStudyTanda: 'var(--color-case-study-tanda)',
  'caseStudySticker-mule': 'var(--color-case-study-sticker-mule)',
  caseStudyStrapi: 'var(--color-case-study-strapi)',
  caseStudyJaneTechnologies: 'var(--color-case-study-jane-technologies)',
  caseStudyDocument360: 'var(--color-case-study-document360)',
  caseStudyAkiflow: 'var(--color-case-study-akiflow)',
  caseStudyPallyy: 'var(--color-case-study-pallyy)',
  caseStudyGiveButter: 'var(--color-case-study-give-butter)',
  caseStudyCci: 'var(--color-case-study-cci)',
  caseStudyOutlier: 'var(--color-case-study-outlier)',
  caseStudySpekit: 'var(--color-case-study-spekit)',
  caseStudyAppcues: 'var(--color-case-study-appcues)',
  caseStudyGetimgai: 'var(--color-case-study-getimgai)',
  caseStudyTldv: 'var(--color-case-study-tldv)',

  darkenCaseStudyAgencyAnalytics: 'var(--color-darken-case-study-agencyanalytics)',
  darkenCaseStudyAhrefs: 'var(--color-darken-case-study-ahrefs)',
  darkenCaseStudyAxios: 'var(--color-darken-case-study-axios)',
  darkenCaseStudyClickup: 'var(--color-darken-case-study-clickup)',
  darkenCaseStudyFigured: 'var(--color-darken-case-study-figured)',
  darkenCaseStudyHive: 'var(--color-darken-case-study-hive)',
  darkenCaseStudyKnak: 'var(--color-darken-case-study-knak)',
  darkenCaseStudyFramer: 'var(--color-darken-case-study-framer)',
  darkenCaseStudyMercury: 'var(--color-darken-case-study-mercury)',
  darkenCaseStudyMissive: 'var(--color-darken-case-study-missive)',
  darkenCaseStudyTanda: 'var(--color-darken-case-study-tanda)',
  'darkenCaseStudySticker-mule': 'var(--color-darken-case-study-sticker-mule)',
  darkenCaseStudyStrapi: 'var(--color-darken-case-study-strapi)',
  darkenCaseStudyCci: 'var(--color-darken-case-study-cci)',
  darkencaseStudyJaneTechnologies: 'var(--color-darken-case-study-jane-technologies)',
  darkencaseStudyDocument360: 'var(--color-darken-case-study-document360)',
  darkencaseStudyAkiflow: 'var(--color-darken-case-study-akiflow)',
  darkenCaseStudyPallyy: 'var(--color-darken-case-study-pallyy)',
  darkenCaseStudyGiveButter: 'var(--color-darken-case-study-give-butter)',
  darkenCaseStudyOutlier: 'var(--color-darken-case-study-outlier)',
  darkenCaseStudyTldv: 'var(--color-darken-case-study-tldv)',
  darkenCaseStudySpekit: 'var(--color-darken-case-study-spekit)',
  darkenCaseStudyAppcues: 'var(--color-darken-case-study-appcues)',
  darkenCaseStudyGetimgai: 'var(--color-darken-case-study-getimgai)',

  postStatusComplete: 'var(--color-postStatusComplete)',
  postStatusInProgress: 'var(--color-postStatusInProgress)',
  postStatusPlanned: 'var(--color-postStatusPlanned)',
  postStatusUnderReview: 'var(--color-postStatusUnderReview)',
  postStatusClosed: 'var(--color-postStatusClosed)',
  postStatusOpen: 'var(--color-postStatusOpen)',
  postStatusBlue100: 'var(--color-postStatusBlue100)',
  postStatusBlue200: 'var(--color-postStatusBlue200)',
  postStatusBlue300: 'var(--color-postStatusBlue300)',
  postStatusBlue400: 'var(--color-postStatusBlue400)',
  postStatusBlue500: 'var(--color-postStatusBlue500)',
  postStatusBlue600: 'var(--color-postStatusBlue600)',
  postStatusBlue700: 'var(--color-postStatusBlue700)',
  postStatusBlue800: 'var(--color-postStatusBlue800)',

  postStatusGreen100: 'var(--color-postStatusGreen100)',
  postStatusGreen200: 'var(--color-postStatusGreen200)',
  postStatusGreen300: 'var(--color-postStatusGreen300)',
  postStatusGreen400: 'var(--color-postStatusGreen400)',
  postStatusGreen500: 'var(--color-postStatusGreen500)',
  postStatusGreen600: 'var(--color-postStatusGreen600)',
  postStatusGreen700: 'var(--color-postStatusGreen700)',
  postStatusGreen800: 'var(--color-postStatusGreen800)',

  postStatusPurple100: 'var(--color-postStatusPurple100)',
  postStatusPurple200: 'var(--color-postStatusPurple200)',
  postStatusPurple300: 'var(--color-postStatusPurple300)',
  postStatusPurple400: 'var(--color-postStatusPurple400)',
  postStatusPurple500: 'var(--color-postStatusPurple500)',
  postStatusPurple600: 'var(--color-postStatusPurple600)',
  postStatusPurple700: 'var(--color-postStatusPurple700)',
  postStatusPurple800: 'var(--color-postStatusPurple800)',

  postStatusRed100: 'var(--color-postStatusRed100)',
  postStatusRed200: 'var(--color-postStatusRed200)',
  postStatusRed300: 'var(--color-postStatusRed300)',
  postStatusRed400: 'var(--color-postStatusRed400)',
  postStatusRed500: 'var(--color-postStatusRed500)',
  postStatusRed600: 'var(--color-postStatusRed600)',
  postStatusRed700: 'var(--color-postStatusRed700)',
  postStatusRed800: 'var(--color-postStatusRed800)',

  white: 'var(--color-white)',
  black: 'var(--color-black)',

  overlay10: 'var(--color-overlay-10)',
  // 'overlay20': 'var(--color-overlay-20)',
  overlay30: 'var(--color-overlay-30)',
  overlay40: 'var(--color-overlay-40)',
  overlay50: 'var(--color-overlay-50)',
  overlay60: 'var(--color-overlay-60)',
  overlay70: 'var(--color-overlay-70)',
  overlay80: 'var(--color-overlay-80)',
  overlay90: 'var(--color-overlay-90)',
  // 'overlay100': 'var(--color-overlay-100)',
  // 'overlay110': 'var(--color-overlay-110)',
  overlay120: 'var(--color-overlay-120)',

  gray10: 'var(--color-gray-10)',
  gray20: 'var(--color-gray-20)',
  gray30: 'var(--color-gray-30)',
  gray40: 'var(--color-gray-40)',
  gray50: 'var(--color-gray-50)',
  gray60: 'var(--color-gray-60)',
  gray70: 'var(--color-gray-70)',
  gray80: 'var(--color-gray-80)',
  gray90: 'var(--color-gray-90)',
  gray100: 'var(--color-gray-100)',
  gray110: 'var(--color-gray-110)',
  gray120: 'var(--color-gray-120)',

  // 02-tomato

  tomato10: 'var(--color-tomato-10)',
  tomato20: 'var(--color-tomato-20)',
  // 'tomato30': 'var(--color-tomato-30)',
  tomato40: 'var(--color-tomato-40)',
  // 'tomato50': 'var(--color-tomato-50)',
  tomato60: 'var(--color-tomato-60)',
  // 'tomato70': 'var(--color-tomato-70)',
  // 'tomato80': 'var(--color-tomato-80)',
  tomato90: 'var(--color-tomato-90)',
  // 'tomato100': 'var(--color-tomato-100)',
  tomato110: 'var(--color-tomato-110)',
  // 'tomato120': 'var(--color-tomato-120)',

  // 02.5-Ruby

  // ruby10: 'var(--color-ruby-10)',
  // ruby20: 'var(--color-ruby-20)',
  // ruby30: 'var(--color-ruby-30)',
  ruby40: 'var(--color-ruby-40)',
  ruby50: 'var(--color-ruby-50)',
  // ruby60: 'var(--color-ruby-60)',
  // ruby70: 'var(--color-ruby-70)',
  // ruby80: 'var(--color-ruby-80)',
  ruby90: 'var(--color-ruby-90)',
  // ruby100: 'var(--color-ruby-100)',
  ruby110: 'var(--color-ruby-110)',
  // ruby120: 'var(--color-ruby-120)',

  // 03-red

  red10: 'var(--color-red-10)',
  red20: 'var(--color-red-20)',
  red30: 'var(--color-red-30)',
  red40: 'var(--color-red-40)',
  red50: 'var(--color-red-50)',
  red60: 'var(--color-red-60)',
  red70: 'var(--color-red-70)',
  red80: 'var(--color-red-80)',
  red90: 'var(--color-red-90)',
  red100: 'var(--color-red-100)',
  red110: 'var(--color-red-110)',
  // 'red120': 'var(--color-red-120)',

  // 04-crimson

  // 'crimson10': 'var(--color-crimson-10)',
  // 'crimson20': 'var(--color-crimson-20)',
  // 'crimson30': 'var(--color-crimson-30)',
  crimson40: 'var(--color-crimson-40)',
  // 'crimson50': 'var(--color-crimson-50)',
  crimson60: 'var(--color-crimson-60)',
  // 'crimson70': 'var(--color-crimson-70)',
  // 'crimson80': 'var(--color-crimson-80)',
  crimson90: 'var(--color-crimson-90)',
  // 'crimson100': 'var(--color-crimson-100)',
  crimson110: 'var(--color-crimson-110)',
  // 'crimson120': 'var(--color-crimson-120)',

  // 05-pink

  // 'pink10': 'var(--color-pink-10)',
  // 'pink20': 'var(--color-pink-20)',
  // 'pink30': 'var(--color-pink-30)',
  pink40: 'var(--color-pink-40)',
  // 'pink50': 'var(--color-pink-50)',
  // 'pink60': 'var(--color-pink-60)',
  // 'pink70': 'var(--color-pink-70)',
  // 'pink80': 'var(--color-pink-80)',
  pink90: 'var(--color-pink-90)',
  // 'pink100': 'var(--color-pink-100)',
  pink110: 'var(--color-pink-110)',
  // 'pink120': 'var(--color-pink-120)',

  // 06-Plum

  // 'plum10': 'var(--color-plum-10)',
  // 'plum20': 'var(--color-plum-20)',
  // 'plum30': 'var(--color-plum-30)',
  plum40: 'var(--color-plum-40)',
  // 'plum50': 'var(--color-plum-50)',
  // 'plum60': 'var(--color-plum-60)',
  // 'plum70': 'var(--color-plum-70)',
  // 'plum80': 'var(--color-plum-80)',
  plum90: 'var(--color-plum-90)',
  // 'plum100': 'var(--color-plum-100)',
  plum110: 'var(--color-plum-110)',
  // 'plum120': 'var(--color-plum-120)',

  // 07-Purple

  // 'purple10': 'var(--color-purple-10)',
  // 'purple20': 'var(--color-purple-20)',
  purple30: 'var(--color-purple-30)',
  purple40: 'var(--color-purple-40)',
  purple50: 'var(--color-purple-50)',
  // 'purple60': 'var(--color-purple-60)',
  // 'purple70': 'var(--color-purple-70)',
  // 'purple80': 'var(--color-purple-80)',
  purple90: 'var(--color-purple-90)',
  // 'purple100': 'var(--color-purple-100)',
  purple110: 'var(--color-purple-110)',
  // 'purple120': 'var(--color-purple-120)',

  // 08-Violet

  // 'violet10': 'var(--color-violet-10)',
  violet20: 'var(--color-violet-20)',
  // 'violet30': 'var(--color-violet-30)',
  violet40: 'var(--color-violet-40)',
  // 'violet50': 'var(--color-violet-50)',
  // 'violet60': 'var(--color-violet-60)',
  // 'violet70': 'var(--color-violet-70)',
  // 'violet80': 'var(--color-violet-80)',
  violet90: 'var(--color-violet-90)',
  // 'violet100': 'var(--color-violet-100)',
  violet110: 'var(--color-violet-110)',
  // 'violet120': 'var(--color-violet-120)',

  // 08.5-iris

  // iris10: 'var(--color-iris-10)',
  // iris20: 'var(--color-iris-20)',
  // iris30: 'var(--color-iris-30)',
  iris40: 'var(--color-iris-40)',
  // iris50: 'var(--color-iris-50)',
  // iris60: 'var(--color-iris-60)',
  // iris70: 'var(--color-iris-70)',
  // iris80: 'var(--color-iris-80)',
  iris90: 'var(--color-iris-90)',
  // iris100: 'var(--color-iris-100)',
  iris110: 'var(--color-iris-110)',
  // iris120: 'var(--color-iris-120)',

  // 09-indigo

  indigo10: 'var(--color-indigo-10)',
  indigo20: 'var(--color-indigo-20)',
  indigo30: 'var(--color-indigo-30)',
  indigo40: 'var(--color-indigo-40)',
  indigo50: 'var(--color-indigo-50)',
  indigo60: 'var(--color-indigo-60)',
  indigo70: 'var(--color-indigo-70)',
  indigo80: 'var(--color-indigo-80)',
  indigo90: 'var(--color-indigo-90)',
  indigo100: 'var(--color-indigo-100)',
  indigo110: 'var(--color-indigo-110)',
  indigo120: 'var(--color-indigo-120)',

  // 10-Blue

  blue10: 'var(--color-blue-10)',
  blue20: 'var(--color-blue-20)',
  blue30: 'var(--color-blue-30)',
  blue40: 'var(--color-blue-40)',
  blue50: 'var(--color-blue-50)',
  blue60: 'var(--color-blue-60)',
  // 'blue70': 'var(--color-blue-70)',
  blue80: 'var(--color-blue-80)',
  blue90: 'var(--color-blue-90)',
  blue100: 'var(--color-blue-100)',
  blue110: 'var(--color-blue-110)',
  // 'blue120': 'var(--color-blue-120)',

  // 11-Cyan

  // 'cyan10': 'var(--color-cyan-10)',
  // 'cyan20': 'var(--color-cyan-20)',
  // 'cyan30': 'var(--color-cyan-30)',
  cyan40: 'var(--color-cyan-40)',
  // 'cyan50': 'var(--color-cyan-50)',
  // 'cyan60': 'var(--color-cyan-60)',
  // 'cyan70': 'var(--color-cyan-70)',
  // 'cyan80': 'var(--color-cyan-80)',
  cyan90: 'var(--color-cyan-90)',
  // 'cyan100': 'var(--color-cyan-100)',
  cyan110: 'var(--color-cyan-110)',
  // 'cyan120': 'var(--color-cyan-120)',

  // 12-Teal

  // 'teal10': 'var(--color-teal-10)',
  // 'teal20': 'var(--color-teal-20)',
  // 'teal30': 'var(--color-teal-30)',
  teal40: 'var(--color-teal-40)',
  // 'teal50': 'var(--color-teal-50)',
  // 'teal60': 'var(--color-teal-60)',
  // 'teal70': 'var(--color-teal-70)',
  // 'teal80': 'var(--color-teal-80)',
  teal90: 'var(--color-teal-90)',
  // 'teal100': 'var(--color-teal-100)',
  teal110: 'var(--color-teal-110)',
  // 'teal120': 'var(--color-teal-120)',

  // 12.5-jade

  // jade10: 'var(--color-jade-10)',
  // jade20: 'var(--color-jade-20)',
  // jade30: 'var(--color-jade-30)',
  // jade40: 'var(--color-jade-40)',
  // jade50: 'var(--color-jade-50)',
  // jade60: 'var(--color-jade-60)',
  // jade70: 'var(--color-jade-70)',
  // jade80: 'var(--color-jade-80)',
  // jade90: 'var(--color-jade-90)',
  // jade100: 'var(--color-jade-100)',
  jade110: 'var(--color-jade-110)',
  // jade120: 'var(--color-jade-120)',

  // 13-Green

  // 'green10': 'var(--color-green-10)',
  green20: 'var(--color-green-20)',
  green30: 'var(--color-green-30)',
  green40: 'var(--color-green-40)',
  green50: 'var(--color-green-50)',
  // 'green60': 'var(--color-green-60)',
  green70: 'var(--color-green-70)',
  // 'green80': 'var(--color-green-80)',
  green90: 'var(--color-green-90)',
  green100: 'var(--color-green-100)',
  green110: 'var(--color-green-110)',
  // 'green120': 'var(--color-green-120)',

  // 14-Grass

  // 'grass10': 'var(--color-grass-10)',
  // 'grass20': 'var(--color-grass-20)',
  grass30: 'var(--color-grass-30)',
  grass40: 'var(--color-grass-40)',
  // 'grass50': 'var(--color-grass-50)',
  // 'grass60': 'var(--color-grass-60)',
  // 'grass70': 'var(--color-grass-70)',
  // 'grass80': 'var(--color-grass-80)',
  grass90: 'var(--color-grass-90)',
  // 'grass100': 'var(--color-grass-100)',
  grass110: 'var(--color-grass-110)',
  // 'grass120': 'var(--color-grass-120)',

  // 15-Orange

  orange10: 'var(--color-orange-10)',
  orange20: 'var(--color-orange-20)',
  orange30: 'var(--color-orange-30)',
  orange40: 'var(--color-orange-40)',
  // 'orange50': 'var(--color-orange-50)',
  orange60: 'var(--color-orange-60)',
  // 'orange70': 'var(--color-orange-70)',
  // 'orange80': 'var(--color-orange-80)',
  orange90: 'var(--color-orange-90)',
  // 'orange100': 'var(--color-orange-100)',
  orange110: 'var(--color-orange-110)',
  // 'orange120': 'var(--color-orange-120)',

  // 16-Brown

  // 'brown10': 'var(--color-brown-10)',
  // 'brown20': 'var(--color-brown-20)',
  // 'brown30': 'var(--color-brown-30)',
  brown40: 'var(--color-brown-40)',
  // 'brown50': 'var(--color-brown-50)',
  // 'brown60': 'var(--color-brown-60)',
  // 'brown70': 'var(--color-brown-70)',
  // 'brown80': 'var(--color-brown-80)',
  brown90: 'var(--color-brown-90)',
  // 'brown100': 'var(--color-brown-100)',
  brown110: 'var(--color-brown-110)',
  // 'brown120': 'var(--color-brown-120)',

  // 17-Sky

  // 'sky10': 'var(--color-sky-10)',
  // 'sky20': 'var(--color-sky-20)',
  // 'sky30': 'var(--color-sky-30)',
  sky40: 'var(--color-sky-40)',
  sky50: 'var(--color-sky-50)',
  // 'sky60': 'var(--color-sky-60)',
  // 'sky70': 'var(--color-sky-70)',
  // 'sky80': 'var(--color-sky-80)',
  sky90: 'var(--color-sky-90)',
  // 'sky100': 'var(--color-sky-100)',
  sky110: 'var(--color-sky-110)',
  // 'sky120': 'var(--color-sky-120)',

  // 18-Mint

  // 'mint10': 'var(--color-mint-10)',
  // 'mint20': 'var(--color-mint-20)',
  mint30: 'var(--color-mint-30)',
  mint40: 'var(--color-mint-40)',
  mint50: 'var(--color-mint-50)',
  // 'mint60': 'var(--color-mint-60)',
  // 'mint70': 'var(--color-mint-70)',
  // 'mint80': 'var(--color-mint-80)',
  mint90: 'var(--color-mint-90)',
  // 'mint100': 'var(--color-mint-100)',
  mint110: 'var(--color-mint-110)',
  // 'mint120': 'var(--color-mint-120)',

  // 19-Lime

  // 'lime10': 'var(--color-lime-10)',
  // 'lime20': 'var(--color-lime-20)',
  // 'lime30': 'var(--color-lime-30)',
  lime40: 'var(--color-lime-40)',
  lime50: 'var(--color-lime-50)',
  // 'lime60': 'var(--color-lime-60)',
  // 'lime70': 'var(--color-lime-70)',
  // 'lime80': 'var(--color-lime-80)',
  lime90: 'var(--color-lime-90)',
  // 'lime100': 'var(--color-lime-100)',
  lime110: 'var(--color-lime-110)',
  // 'lime120': 'var(--color-lime-120)',

  // 20-Yellow

  yellow10: 'var(--color-yellow-10)',
  yellow20: 'var(--color-yellow-20)',
  yellow30: 'var(--color-yellow-30)',
  yellow40: 'var(--color-yellow-40)',
  // 'yellow50': 'var(--color-yellow-50)',
  yellow60: 'var(--color-yellow-60)',
  yellow70: 'var(--color-yellow-70)',
  // 'yellow80': 'var(--color-yellow-80)',
  yellow90: 'var(--color-yellow-90)',
  // 'yellow100': 'var(--color-yellow-100)',
  yellow110: 'var(--color-yellow-110)',
  // 'yellow120': 'var(--color-yellow-120)',

  // 21-Amber

  // amber10: 'var(--color-amber-10)',
  // amber20: 'var(--color-amber-20)',
  // amber30: 'var(--color-amber-30)',
  // amber40: 'var(--color-amber-40)',
  // amber50: 'var(--color-amber-50)',
  // amber60: 'var(--color-amber-60)',
  // amber70: 'var(--color-amber-70)',
  // amber80: 'var(--color-amber-80)',
  amber90: 'var(--color-amber-90)',
  // amber100: 'var(--color-amber-100)',
  amber110: 'var(--color-amber-110)',
  // amber120: 'var(--color-amber-120)',

  'rgba-7': 'var(--color-rgba-7)',
  'rgba-8': 'var(--color-rgba-8)',
  'rgba-9': 'var(--color-rgba-9)',
  'rgba-10': 'var(--color-rgba-10)',
  'rgba-17': 'var(--color-rgba-17)',

  elevation1: 'var(--color-elevation-1)',
  elevation2: 'var(--color-elevation-2)',

  border: 'var(--color-border)',
} as const;

export enum ColorNames {
  tomato = 'tomato',
  crimson = 'crimson',
  pink = 'pink',
  purple = 'purple',
  violet = 'violet',
  blue = 'blue',
  cyan = 'cyan',
  teal = 'teal',
  grass = 'grass',
  orange = 'orange',
  brown = 'brown',
  sky = 'sky',
  mint = 'mint',
  iris = 'iris',
  lime = 'lime',
  ruby = 'ruby',
  plum = 'plum',
  yellow = 'yellow',
}

export const StaticColors = {
  postStatusComplete: '#6cd345',
  postStatusInProgress: '#c17aff', // duplicate on css purple
  postStatusPlanned: '#1fa0ff', // duplicate on css lightBlue
  postStatusUnderReview: '#85b5b5', // duplicate on css underReview
  postStatusOpen: '#a6a6a6',
  postStatusClosed: '#ed2b2b', // duplicate on css red
  postStatusBlue100: '#81c8c8',
  postStatusBlue200: '#81b1ff',
  postStatusBlue300: '#00c0fd',
  postStatusBlue400: '#1fa0ff', // duplicate on css - lightBlue
  postStatusBlue500: '#6b69ff',
  postStatusBlue600: '#1e58ed',
  postStatusBlue700: '#0063ae',
  postStatusBlue800: '#040077',
  postStatusGreen100: '#00e4a1',
  postStatusGreen200: '#6cd345', // duplicate on css postStatusComplete
  postStatusGreen300: '#04c168',
  postStatusGreen400: '#1cbc9c',
  postStatusGreen500: '#1e907a',
  postStatusGreen600: '#048944',
  postStatusGreen700: '#00652a',
  postStatusGreen800: '#436652',
  postStatusPurple100: '#ee82ff',
  postStatusPurple200: '#fd37f1',
  postStatusPurple300: '#c17aff', // duplicate on css purple
  postStatusPurple400: '#b118c6',
  postStatusPurple500: '#9a4fb9',
  postStatusPurple600: '#c50a8b',
  postStatusPurple700: '#a60174',
  postStatusPurple800: '#7c0088',
  postStatusRed100: '#ff9367',
  postStatusRed200: '#f4ae27', // duplicate on css - yellowWhite4
  postStatusRed300: '#fd7f00',
  postStatusRed400: '#fa7d9b',
  postStatusRed500: '#f0787a',
  postStatusRed600: '#fd563d',
  postStatusRed700: '#cd4a12',
  postStatusRed800: '#a50000',
  canny: '#525df9',
  white: '#ffffff',
  darkThemeBackground: '#111111',
  darkBlue: '#1a1523',
  middleBlue: '#7D7D83',
  redWhiteColor: '#eeeeee',
} as const;

export type ColorKeys = keyof typeof Colors;
export type ColorValues = ObjectValues<typeof Colors>;
export default Colors;
